// @flow
import React, { useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
// import PrintGoalcard from 'components/shared/PrintGoalcard/index';
import bgImage from 'assets/images/background.png';
import { sendAnalyticsEvent } from 'utils/analyticsWrapper';
import { formatToCurrency } from 'utils/numbers';
import { ReactComponent as Test } from 'assets/images/success-give-goalcard/container-free-goalcard.svg';

import SuccessPageDesktop from './Desktop/index';
import SuccessPageMobile from './Mobile/index';

type SuccessPageProps = {
  purchasedGoalcard: { amount: Number, kidFirstName: string, GoalcardImg: string },
};

const SuccessPage = (props: SuccessPageProps) => {
  const version = !isMobile ? <SuccessPageDesktop /> : <SuccessPageMobile />;

  return (
    <div>
      { version }
    </div>
  );
};

// Map Props
const mapStateToProps = (state) => ({
  purchasedGoalcard: state.purchase.purchasedGoalcard,
  goalcardPayload: state.purchase.goalcardPayload,
});

// Map Dispatch
const mapDispatchToProps = () => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SuccessPage);
